export default __webpack_public_path__ + "static/media/dashboardWhite.911bea78.svg";